import MiniProgramPage from 'D:/zxl/workspace/saveWorkSpace/nongtou-uni/subpackage/manager/report.vue'
wx.createPage(MiniProgramPage)